import script from "./StatusSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusSelect.vue?vue&type=script&lang=ts&setup=true"

import "./StatusSelect.vue?vue&type=style&index=0&id=08a5b1e3&scoped=true&lang=scss"
import "./StatusSelect.vue?vue&type=style&index=1&id=08a5b1e3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a5b1e3"]])

export default __exports__